export default function createRowsResponseParser(itemMapper) {
    return ({rows, count, ...other}) => ({
        rows: itemMapper ? rows.map(itemMapper) : rows,
        count: count === 'lot' ? Infinity : parseInt(count),
        ...other,
    })
}